import React, { Component } from 'react';
import { authentication } from '../../services/Authentication';
import { config } from './Constants';
import helpers from '../../Function';
import moment from 'moment';
import { withRouter } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import HeaderTab from "./Header";

class CustomerProfile extends Component {
    constructor(props) {
        super(props);
        const { jwt, user_permission } = authentication.currentUserValue;
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const parame_phone = params.get('phone');
        const parame_title = params.get('title');
        /*
        7781  Nirvana Press 1 แจ้งซ่อม
        7782  Nirvana Press 2 ร้องเรียน
        7783Nirvana Press 3 สอบถามหรือเจ้งเรื่องอื่นๆ
        
        */
        this.state = {
            jwt: jwt,
            user_permission: user_permission,
            pages: [],
            residence_pages: [],
            project_home: [],
            house_no: [{ display: '-', value: '' }],
            src_phone: (parame_phone != 'null' ? parame_phone : ''),
            src_title: (parame_title == "7781" && 1 || parame_title == "7782" && 2 || parame_title == "7783" && 3 || ''),
            src_home_number: '',
            src_name: '',
            src_project: '',
            adv_startdate: '',
            adv_enddate: '',
            adv_member: '',
            adv_phone: '',
            adv_project: '',
            adv_home_number: '',
            adv_status: '',
            adv_category: '',
            adv_service_status: '',
            pro_house_no: '-',
            pro_plot: '-',
            pro_phone: '-',
            pro_name: '-',
            pro_email: '-',
            pro_delivery_date: '-',
            pro_expire_date: '-',
            pro_project_name: '-',
            pro_address: '-',
            pro_residenceid: '',
            pro_project_status: '',
            page: 0,
            rowsPerPage: 10,
            WorkSheetIsOpen: false,
            matches: window.matchMedia("(min-width: 768px)").matches
        }

        this.handleDetail = this.handleDetail.bind(this);
        this.change = this.change.bind(this);
        this.newForm = this.newForm.bind(this);
        this.onKeyPressed = this.onKeyPressed.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.reloadData = this.reloadData.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onClear = this.onClear.bind(this);
        this.onClickSearch = this.onClickSearch.bind(this);
        this.onClickHouse = this.onClickHouse.bind(this);

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

        this.openWorkSheet = this.openWorkSheet.bind(this);
        this.closeWorkSheet = this.closeWorkSheet.bind(this);

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/project_homes', requestOptions)
            .then(res => res.json())
            .then(data => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //alert(data.status);
                let FromApi = data.data.map(datas => {
                    return { value: datas.id, display: datas.name_th }
                });

                this.setState({
                    project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                });

            });

        this.reloadData('');

    }

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
        const handler = e => this.setState({ matches: e.matches });
        window.matchMedia("(min-width: 768px)").addListener(handler);
    }

    reloadData(projectid) {

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        console.log("*******************this.state.src_phone:" + this.state.src_phone);
        console.log("*******************projectid:" + projectid);
        console.log("*******************this.state.src_home_number:" + this.state.src_home_number);
        console.log("*******************this.state.src_name:" + this.state.src_name);

        this.setState({
            residence_pages: [],
            pro_house_no: '-',
            pro_plot: '-',
            pro_phone: '-',
            pro_name: '-',
            pro_email: '-',
            pro_delivery_date: '',
            pro_expire_date: '-',
            pro_project_name: '-',
            pro_address: '-',
            pro_residenceid: '-',
            pro_project_status: '-'
        });

        if (this.state.src_phone || projectid || this.state.src_home_number || this.state.src_name) {
            /*
            
*/
            if (this.state.src_phone || this.state.src_name) {
                fetch(config.url.API_URL + '/groupby_projecthome/?phone=' + (this.state.src_phone ? this.state.src_phone : '')
                    + '&name=' + (this.state.src_name ? this.state.src_name : ''), requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        //alert(data.status);

                        if (Array.isArray(data.data) && data.data.length) {
                            let FromApi = data.data.map(datas => {
                                return { value: datas._id._id, display: datas._id.name_th }
                            });
                            this.setState({
                                project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                            });
                        }

                    });
            }

            fetch(config.url.API_URL + '/residences/?phone=' + (this.state.src_phone ? this.state.src_phone : '')
                + '&projecthomeid=' + (projectid ? projectid : '')
                + '&houseno=' + (this.state.src_home_number ? this.state.src_home_number : '')
                + '&name=' + (this.state.src_name ? this.state.src_name : '')
                , requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {                      
                        let FromApi = data.data.map(datas => {
                            var address = datas.address;
                            var project_homes_name = datas.project_name;
                            
                            // if (datas.project_homes) {
                            //     project_homes_name = datas.project_homes[0].name_th;
                            //     address = (datas.project_homes[0].moo && "ม. " + datas.project_homes[0].moo)
                            //         + (datas.project_homes[0].soi && " ซ. " + datas.project_homes[0].soi)
                            //         + (datas.project_homes[0].road && " ถ. " + datas.project_homes[0].road)
                            //         + (datas.project_homes[0].sub_district && " ต./แขวง " + datas.project_homes[0].sub_district)
                            //         + (datas.project_homes[0].district && " อ./เขต " + datas.project_homes[0].district)
                            //         + (datas.project_homes[0].province && " จ. " + datas.project_homes[0].province);
                            // }

                            var ownerName = ""
                            if (Array.isArray(datas.customer) && datas.customer.length > 0) {
                                var customer = datas.customer[datas.customer.length - 1];

                                if (customer.customer_name == '') {
                                    customer = datas.customer[0];
                                }

                                ownerName = (customer.customer_name ? customer.customer_name : "");
                            }


                            return {
                                id: datas.id,
                                house_no: datas.house_no,
                                plot: datas.plot,
                                address: address,
                                project_name: project_homes_name,
                                ownerName: ownerName
                            }
                        });

                        console.log(`from api`, FromApi)

                        this.setState({
                            residence_pages: [].concat(FromApi)
                        });
                        /*
                        const script = document.createElement("script");
    
                        script.src = "/js/customerprofile.js";
                        script.async = true;
                        document.body.appendChild(script);
                        */
                        var datas = data.data[0];
                        var name_th = datas.project_name;
                        var address = datas.address;
                        

                        // if (Array.isArray(datas.project_homes) && datas.project_homes.length) {
                        //     name_th = datas.project_homes[0].name_th;
                        //     address = "บ้านเลขที่" + datas.house_no
                        //         + (datas.project_homes[0].moo && "หมู่ " + datas.project_homes[0].moo)
                        //         + (datas.project_homes[0].soi && " ซอย " + datas.project_homes[0].soi)
                        //         + (datas.project_homes[0].road && " ถนน " + datas.project_homes[0].road)
                        //         + " ตำบล/แขวง " + datas.project_homes[0].sub_district
                        //         + " อำเภอ/เขต " + datas.project_homes[0].district
                        //         + " จังหวัด " + datas.project_homes[0].province;
                        // }


                        var customerName = ""
                        var customerTell = ""
                        var customerEmail = ""
                        if (Array.isArray(datas.customer) && datas.customer.length > 0) {
                            var customer = datas.customer[datas.customer.length - 1];

                            if (customer.customer_name == '') {
                                customer = datas.customer[0];
                            }

                            customerName = (customer.customer_name ? customer.customer_name : "");
                            customerTell = (customer.customer_tell.length ? customer.customer_tell[0].tell : "")
                            customerEmail = (customer.customer_email.length ? datas.customer[0].customer_email[0].email : "")
                        }


                        var curdate = moment(new Date());
                        var expired_insurance = moment(datas.expired_insurance);

                        var diffdate = curdate.diff(expired_insurance, 'days');

                        this.setState({
                            pro_house_no: datas.house_no,
                            pro_plot: datas.plot,
                            pro_phone: customerTell,
                            pro_name: customerName,
                            pro_email: customerEmail,
                            pro_delivery_date: (datas.delivery_date ? moment(datas.delivery_date).format('DD/MM/YYYY') : '-'),
                            pro_expire_date: (datas.expired_insurance ? moment(datas.expired_insurance).format('DD/MM/YYYY') : '-'),
                            pro_project_name: name_th,
                            pro_address: address,
                            pro_residenceid: datas._id,
                            pro_project_status: (datas.expired_insurance && helpers.getProjectStatus((diffdate > 0 ? 'expire' : 'insurance')) || '-')
                        })
                    }
                });
        } else {
            this.setState({
                pages: [],
                pro_house_no: '-',
                pro_plot: '-',
                pro_phone: '-',
                pro_name: '-',
                pro_email: '-',
                pro_delivery_date: '',
                pro_expire_date: '-',
                pro_project_name: '-',
                pro_address: '-',
                pro_residenceid: '-',
                pro_project_status: '-'
            });
        }
    }

    change(e) {

        this.setState({
            [e.target.name]: e.target.value
        });
        /*
        if(e.target.name=="src_project"){
            this.onSearch(e.target.value);
        }
        */
    }

    handleDetail(e) {
        var data = { id: e.currentTarget.attributes["id"].value, page: "customerprofile" }
        //alert(e.currentTarget.attributes["id"].value);
        //this.props.history.push("/detail-case", { ...data })
        //this.props.history.push("/detail-case", data)
        this.props.history.push({
            pathname: '/detail-case/' + e.currentTarget.attributes["id"].value,
            //search: '?query=abc',
            state: { detail: data }
        })
    }

    newForm(e) {
        this.props.history.push("/new-form/" + (this.state.pro_residenceid ? "?id=" + this.state.pro_residenceid + "&phone=" + this.state.src_phone : "") + (this.state.src_title ? "&title=" + this.state.src_title : ""));
    }

    onClickSearch() {
        this.onSearch(this.state.src_project);
    }

    onKeyPressed(e) {
        if (e.key === "Enter") {
            this.onSearch(this.state.src_project);
        }

    }

    onClickHouse(e) {
        //alert(e.currentTarget.attributes["data-id"].value)
        //e.currentTarget.attributes["data-id"].value
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/residences/' + e.currentTarget.attributes["data-id"].value
            , requestOptions)
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data.data)) {

                    var datas = data.data[0];
                    var name_th = "";
                    var address = "";

                    if (Array.isArray(datas.project_homes) && datas.project_homes.length) {
                        name_th = datas.project_homes[0].name_th;
                        address = "บ้านเลขที่" + datas.house_no
                            + (datas.project_homes[0].moo && "หมู่ " + datas.project_homes[0].moo)
                            + (datas.project_homes[0].soi && " ซอย " + datas.project_homes[0].soi)
                            + (datas.project_homes[0].road && " ถนน " + datas.project_homes[0].road)
                            + " ตำบล/แขวง " + datas.project_homes[0].sub_district
                            + " อำเภอ/เขต " + datas.project_homes[0].district
                            + " จังหวัด " + datas.project_homes[0].province;
                    }

                    var cus_phone = "";
                    var cus_name = "";
                    var cus_email = "";

                    if (datas.customer.length) {
                        var customer = datas.customer[datas.customer.length - 1];

                        if (customer.customer_name == '') {
                            customer = datas.customer[0];
                        }

                        cus_phone = (customer.customer_tell.length ? customer.customer_tell[0].tell : "");
                        cus_name = (customer.customer_name ? customer.customer_name : "");
                        cus_email = (customer.customer_email.length ? datas.customer[0].customer_email[0].email : "")
                    }

                    var curdate = moment(new Date());
                    var expired_insurance = moment(datas.expired_insurance);

                    var diffdate = curdate.diff(expired_insurance, 'days');

                    this.setState({
                        pro_house_no: datas.house_no,
                        pro_plot: datas.plot,
                        pro_phone: cus_phone,
                        pro_name: cus_name,
                        pro_email: cus_email,
                        pro_delivery_date: (datas.delivery_date ? moment(datas.delivery_date).format('DD/MM/YYYY') : '-'),
                        pro_expire_date: (datas.expired_insurance ? moment(datas.expired_insurance).format('DD/MM/YYYY') : '-'),
                        pro_project_name: name_th,
                        pro_address: address,
                        pro_residenceid: datas._id,
                        pro_project_status: (datas.expired_insurance && helpers.getProjectStatus((diffdate > 0 ? 'expire' : 'insurance')) || '-')
                    })


                }
            });
    }

    onKeyUp(e) {
        if (this.state.src_phone == '' && this.state.src_name == '' && this.state.src_project == '' && this.state.src_home_number == '') {
            this.setState({
                pages: [],
                pro_house_no: '-',
                pro_plot: '-',
                pro_phone: '-',
                pro_name: '-',
                pro_email: '-',
                pro_delivery_date: '',
                pro_expire_date: '-',
                pro_project_name: '-',
                pro_address: '-',
                pro_residenceid: '-',
                pro_project_status: '-'
            });
        }
    }

    onSearch(projectid) {
        this.reloadData(projectid);
    }

    SearchSubmit(e) {
        e.preventDefault();
    }

    onClear() {
        this.setState({
            pages: [],
            house_no: [{ display: '-', value: '' }],
            pro_house_no: '-',
            pro_plot: '-',
            pro_phone: '-',
            pro_name: '-',
            pro_email: '-',
            pro_delivery_date: '',
            pro_expire_date: '-',
            pro_project_name: '-',
            pro_address: '-',
            pro_residenceid: '-',
            pro_project_status: '-',
            src_home_number: '',
            src_phone: '',
            src_name: '',
            src_project: '',
            residence_pages:[]
        });

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/project_homes', requestOptions)
            .then(res => res.json())
            .then(data => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //alert(data.status);
                let FromApi = data.data.map(datas => {
                    return { value: datas.id, display: datas.name_th }
                });

                this.setState({
                    project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                });

            });

        document.getElementById("src-form").reset();
    }
    /*
    7781  Nirvana Press 1 แจ้งซ่อม
    7782  Nirvana Press 2 ร้องเรียน
    7783Nirvana Press 3 สอบถามหรือเจ้งเรื่องอื่นๆ
    
    */

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    openWorkSheet(e) {

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/service_complaints/?bystatus=1&houseno=' + e.currentTarget.attributes["data-id"].value
            , requestOptions)
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data.data) && data.data.length) {
                    let FromApi = data.data.map(datas => {
                        //var dcreated = new Date();
                        return {
                            id: datas._id,
                            number: datas.service_number,
                            service_date: moment(datas.created).format('DD/MM/YYYY'),
                            service_time: moment(datas.created).format('H:mm'),
                            member_name: datas.member_first_name + ' ' + datas.member_last_name,
                            phone_come: datas.income_phone,
                            project_name: datas.project_homes[0].name_th,
                            home_number: datas.home_number,
                            project_status: helpers.getProjectStatus(datas.project_status),
                            category: (Array.isArray(datas.service_categorys) && datas.service_categorys.length ?
                                datas.service_categorys[0].name_th : ''),
                            warranty_date: moment(datas.delivery_date).format('DD/MM/YYYY') + ' - ' + moment(datas.expired_insurance).format('DD/MM/YYYY'),
                            title: (Array.isArray(datas.service_types) && datas.service_types.length ?
                                datas.service_types[0].name_th : ''),
                            contact: helpers.getContactChannel(datas.contact_chanel),
                            service_status: helpers.getServiceStatus(datas.service_status),
                            sla: helpers.getSla(moment(datas.created), (Array.isArray(datas.service_categorys) && datas.service_categorys.length ?
                                datas.service_categorys[0].name_th : ''), datas.service_status)
                        }
                    });

                    this.setState({
                        pages: [].concat(FromApi)
                    });
                } else {
                    this.setState({
                        pages: []
                    });

                }

            });

        this.setState({ WorkSheetIsOpen: true });
    }

    closeWorkSheet() {
        this.setState({
            pages: []
        });
        this.setState({ WorkSheetIsOpen: false });
    }

    render() {

        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.residence_pages.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">เปิดใบงาน</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">เปิดใบงาน</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                <HeaderTab />
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div>
                                    {this.state.matches && (<div className="card-header">
                                        <form id="src-form" onSubmit={this.SearchSubmit}>
                                            <h2><img src={"../dist/img/icon/ic_tab_profile.png"} width="auto" height={50} /> Customer Profile
                                                {(this.state.src_title == 1 && " / แจ้งซ่อม" || this.state.src_title == 2 && " / ร้องเรียน" || this.state.src_title == 3 && " / สอบถามหรือเจ้งเรื่องอื่นๆ" || '')}
                                            </h2>

                                            <div className="row ml-3 mt-3">
                                                <div className="col-2">
                                                    <div className="row">
                                                        <span className="label col-4 text-center">เบอร์โทรเข้า</span>
                                                        <input type="text" className="form-custom label-data col-8" id="src_phone" name="src_phone" onKeyUp={this.onKeyUp} onKeyPress={this.onKeyPressed} onChange={this.change} defaultValue={this.state.src_phone} style={{ width: 200, height: 45 }} />
                                                    </div>
                                                </div>

                                                <div className="col-3">
                                                    <div className="row">
                                                        <span className="label col-5 text-center">ชื่อ-นามสกุล</span>
                                                        <input type="text" className="form-custom label-data col-7" id="src_name" name="src_name" onKeyUp={this.onKeyUp} onKeyPress={this.onKeyPressed} onChange={this.change} defaultValue={this.state.src_name} style={{ width: 200, height: 45 }} />
                                                    </div>
                                                </div>

                                                <div className="col-3">
                                                    <div className="row">
                                                        <span className="label col-3 text-center">โครงการ</span>
                                                        <select className="form-custom label-data col-9" id="src_project" name="src_project" style={{ width: 220, height: 45 }} onChange={this.change}>
                                                            {this.state.project_home.map((datas) => <option value={datas.value}>{datas.display}</option>)}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-2">
                                                    <div className="row">
                                                        <span className="label col-5 text-center">เลขที่บ้าน/ห้อง</span>
                                                        <input type="text" className="form-custom label-data col-7" id="src_home_number" name="src_home_number" onKeyUp={this.onKeyUp} onKeyPress={this.onKeyPressed} onChange={this.change} defaultValue="" style={{ width: 200, height: 45 }} />
                                                    </div>
                                                </div>

                                                <div className="col-2">
                                                    <div className="row">
                                                        <button type="text" className="form-custom label-data col-3 ml-5" id="src_ok" onClick={this.onClickSearch}>ค้นหา</button>
                                                        <button type="text" className="form-custom label-data col-3 ml-1" id="src_clear" onClick={this.onClear}>เคลียร์</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>)}
                                    {!this.state.matches && (<div className="card-header">
                                        <form id="src-form" onSubmit={this.SearchSubmit}>
                                            <h3><img src={"../dist/img/icon/ic_tab_profile.png"} width="auto" height={30} /> Customer Profile
                                                    {(this.state.src_title == 1 && " / แจ้งซ่อม" || this.state.src_title == 2 && " / ร้องเรียน" || this.state.src_title == 3 && " / สอบถามหรือเจ้งเรื่องอื่นๆ" || '')}
                                            </h3>

                                            <div className="row">
                                                <div className="row mb-3">
                                                    <div className="col-sm-3">เบอร์โทรเข้า</div>
                                                    <div className="col-sm-5">
                                                        <input type="text" className="form-custom label-data col-8" id="src_phone" name="src_phone" onKeyUp={this.onKeyUp} onKeyPress={this.onKeyPressed} onChange={this.change} defaultValue={this.state.src_phone} style={{ width: 200, height: 45 }} />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-sm-3">ชื่อ-นามสกุล</div>
                                                    <div className="col-sm-5">
                                                        <input type="text" className="form-custom label-data col-8" id="src_name" name="src_name" onKeyUp={this.onKeyUp} onKeyPress={this.onKeyPressed} onChange={this.change} defaultValue={this.state.src_name} style={{ width: 200, height: 45 }} />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-sm-3">โครงการ</div>
                                                    <div className="col-sm-5">
                                                        <select className="form-custom label-data col-8" id="src_project" name="src_project" style={{ width: 220, height: 45 }} onChange={this.change}>
                                                            {this.state.project_home.map((datas) => <option value={datas.value}>{datas.display}</option>)}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-sm-3">เลขที่บ้าน/ห้อง</div>
                                                    <div className="col-sm-5">
                                                        <input type="text" className="form-custom label-data col-8" id="src_home_number" name="src_home_number" onKeyUp={this.onKeyUp} onKeyPress={this.onKeyPressed} onChange={this.change} defaultValue="" style={{ width: 200, height: 45 }} />
                                                    </div>
                                                </div>
                                                <div className="row mb-12">
                                                    <div className="col-sm-3">
                                                    </div>
                                                    <div className="col-sm-5">
                                                        <button type="button" className="btn btn-dark" id="src_ok" onClick={this.onClickSearch}>ค้นหา</button>&nbsp;&nbsp;
                                                        <button type="button" className="btn btn-light" id="src_clear" onClick={this.onClear}>เคลียร์</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>)}
                                </div>
                                {/* .card-header */}
                                <div className="card-body">
                                    <div >
                                        {this.state.matches && (
                                            <div className="row">
                                                <div className="cus-col-label-1">
                                                    <div className="number text-center" style={{ maxHeight: "450px", overflowY: "auto" }}>
                                                        <div>บ้านเลขที่</div>
                                                        {this.state.pro_house_no}
                                                    </div>
                                                </div>
                                                <div className="col-10 card-detail">
                                                    <div className="row mt-3">
                                                        <div className="col-12">
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">แปลง</span>
                                                                        </div>
                                                                        <div className="col-2">
                                                                            <div className="form-custom">{this.state.pro_plot}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">ชื่อนามสกุล</span>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <div className="form-custom">{this.state.pro_name}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">ติดต่อ</span>
                                                                        </div>
                                                                        <div className="cus-col-label-2">
                                                                            <div className="form-custom">{this.state.pro_phone}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">วันรับมอบ</span>
                                                                        </div>
                                                                        <div className="cus-col-label-1">
                                                                            <div className="form-custom">{this.state.pro_delivery_date}</div>
                                                                        </div>
                                                                        <div className="col-1 text-right">
                                                                            <span className="label">หมดรับประกัน</span>
                                                                        </div>
                                                                        <div className="cus-col-label-1">
                                                                            <div className="form-custom">{this.state.pro_expire_date}</div>
                                                                        </div>
                                                                        <div className="cus-col-label-05 text-right">
                                                                            <span className="label">สถานะ</span>
                                                                        </div>
                                                                        <div className="cus-col-label-1">
                                                                            <div className="form-custom">{this.state.pro_project_status}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">โครงการ</span>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <div className="form-custom">{this.state.pro_project_name}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">ที่อยู่</span>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <div className="form-custom">{this.state.pro_address}</div>
                                                                        </div>
                                                                        <div className="col-6 text-right">
                                                                            {(this.state.user_permission[259].permission == 1 &&
                                                                                <button className="btn-cancel" onClick={this.newForm}>
                                                                                    <img src="../dist/img/icon/ic_tab_add.png" width="auto" height="30" /> New Form
                                                                        </button>
                                                                            )}

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>)}
                                        {!this.state.matches && (
                                            <div className="row">
                                                <div className="col-10">
                                                    <div className="col-6">
                                                        <h3 style={{ overflowY: "auto" }}>
                                                            <div>บ้านเลขที่</div>
                                                            {this.state.pro_house_no}
                                                        </h3>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-12">
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="col-3">
                                                                            <span className="label">แปลง</span>
                                                                        </div>
                                                                        <div className="col-9">
                                                                            <div className="form-custom">{this.state.pro_plot}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="col-3">
                                                                            <span className="label">ชื่อ นามสกุล</span>
                                                                        </div>
                                                                        <div className="col-9">
                                                                            <div className="form-custom">{this.state.pro_name}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="col-3">
                                                                            <span className="label">ติดต่อ</span>
                                                                        </div>
                                                                        <div className="col-9">
                                                                            <div className="form-custom">{this.state.pro_phone}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="col-3">
                                                                            <span className="label">วันรับมอบ</span>
                                                                        </div>
                                                                        <div className="col-9">
                                                                            <div className="form-custom">{this.state.pro_delivery_date}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="col-3">
                                                                            <span className="label">หมดรับประกัน</span>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <div className="form-custom">{this.state.pro_expire_date}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="col-3">
                                                                            <span className="label">สถานะ</span>
                                                                        </div>
                                                                        <div className="col-9">
                                                                            <div className="form-custom">{this.state.pro_project_status}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="col-3">
                                                                            <span className="label">โครงการ</span>
                                                                        </div>
                                                                        <div className="col-9">
                                                                            <div className="form-custom">{this.state.pro_project_name}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="col-3">
                                                                            <span className="label">ที่อยู่</span>
                                                                        </div>
                                                                        <div className="col-9">
                                                                            <div className="form-custom">{this.state.pro_address}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="col-12">
                                                                            {(this.state.user_permission[259].permission == 1 &&
                                                                                <button className="btn-cancel" onClick={this.newForm}>
                                                                                    <img src="../dist/img/icon/ic_tab_add.png" width="auto" height="30" /> New Form
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>)}
                                    </div>
                                </div>
                                <div className="card-body">
                                    <TableContainer component={Paper}>
                                        <Table className={StyledTableCell} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell>บ้านเลขที่</StyledTableCell>
                                                    <StyledTableCell>แปลง</StyledTableCell>
                                                    <StyledTableCell>โครงการ</StyledTableCell>
                                                    <StyledTableCell>ที่อยู่</StyledTableCell>
                                                    <StyledTableCell>เจ้าของบ้าน</StyledTableCell>
                                                    {(this.state.user_permission[258].permission == 1 &&
                                                        <StyledTableCell style={{ width: "120px" }}>Case</StyledTableCell>
                                                    )}

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.residence_pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map(data => {
                                                            return (
                                                                <StyledTableRow data-href="" data-id={data.id} onClick={this.onClickHouse} >
                                                                    <StyledTableCell>{data.house_no}</StyledTableCell>
                                                                    <StyledTableCell>{data.plot}</StyledTableCell>
                                                                    <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.address}</StyledTableCell>
                                                                    <StyledTableCell>{data.ownerName}</StyledTableCell>
                                                                    {(this.state.user_permission[258].permission == 1 &&
                                                                        <StyledTableCell>
                                                                            <button className="form-custom" data-id={data.house_no} onClick={this.openWorkSheet} >
                                                                                <img src="../dist/img/icon/ic_worksheet_01.png" width="auto" height="auto" /> WorkSheet</button>
                                                                        </StyledTableCell>
                                                                    )}
                                                                </StyledTableRow>)
                                                        })
                                                }
                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.residence_pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                    <Modal show={this.state.WorkSheetIsOpen} onHide={this.closeWorkSheet} size="xl">
                                        <ModalHeader>
                                            <ModalTitle>รายการแจ้งซ่อม</ModalTitle>
                                        </ModalHeader>
                                        <ModalBody>
                                            <form id="form-serach">
                                                <div className="row mb-3">
                                                    <div className="col-sm-12 table-responsive">
                                                        <table id="table-main" className="table">
                                                            <thead className="table-base">
                                                                <tr>
                                                                    <th>เลขที่</th>
                                                                    <th>วันที่รับเรื่อง</th>
                                                                    <th>เวลา</th>
                                                                    <th>ผู้แจ้ง</th>
                                                                    <th>เบอร์โทรเข้า</th>
                                                                    <th>โครงการ</th>
                                                                    <th>บ้านเลขที่</th>
                                                                    <th>สถานะ</th>
                                                                    <th>เรื่อง</th>
                                                                    <th>ระยะเวลาประกัน</th>
                                                                    <th>สถานะในงาน</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.pages.length > 0 ? this.state.pages.map((data) => (
                                                                    <tr data-href="" id={data.id} onClick={this.handleDetail} >
                                                                        <td>{data.number}</td>
                                                                        <td>{data.service_date}</td>
                                                                        <td>{data.service_time}</td>
                                                                        <td>{data.member_name}</td>
                                                                        <td>{data.phone_come}</td>
                                                                        <td>{data.project_name}</td>
                                                                        <td>{data.home_number}</td>
                                                                        <td>{data.project_status}</td>
                                                                        <td>{data.category}</td>
                                                                        <td>{data.warranty_date}</td>
                                                                        <td>{data.service_status}</td>
                                                                    </tr>
                                                                )) : <tr><td colSpan={11} style={{ textAlign: "center" }}>ไม่พบข้อมูล</td></tr>}

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </form>
                                        </ModalBody>
                                        <ModalFooter>
                                            <button className="btn btn-default" onClick={this.closeWorkSheet}>ตกลง</button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
            </div>
        );
    }
}

export default withRouter(CustomerProfile);